import React from "react";
import { Offcanvas } from "react-bootstrap";
import FinalExistingB2cLp from "../../../Private/B2cReferral/Edit/Components/B2cLandingPages/Final/FinalExisting";

const ExistingCustomerModal = ({
  isOpen,
  initData,
  toggleModal,
  loyaltyData,
}) => {
  return (
    <Offcanvas
      show={isOpen}
      scroll={false}
      placement="end"
      onHide={toggleModal}
      className={`existing-customer-referral-canvas`}
    >
      <div className="b2c-existing-shortlink-root">
        <FinalExistingB2cLp
          showBackBtn={true}
          loyaltyData={loyaltyData}
          toggleModal={toggleModal}
          resData={initData?.referral}
          currencyView={initData?.currency ?? ""}
        />
      </div>
    </Offcanvas>
  );
};

export default ExistingCustomerModal;
